import { useNavigate } from "react-router-dom";

/**
 * Hook für zuverlässige Hash-Navigation in TYPO3-Umgebung
 * Stellt sicher, dass alle internen Links mit Hash-Prefix funktionieren
 */
export const useHashNavigation = () => {
  const navigate = useNavigate();

  /**
   * Navigiert zu einem Pfad mit Hash-Prefix für TYPO3-Kompatibilität
   * @param path - Der Pfad ohne führenden Hash (z.B. "/rechnungen/neu")
   */
  const navigateWithHash = (path: string) => {
    // Entferne führenden Slash, falls vorhanden, da wir # verwenden
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    
    // Setze direkt die Hash-URL - das umgeht alle React Router Probleme
    window.location.href = window.location.pathname + window.location.search + '#/' + cleanPath;
  };

  /**
   * Prüft, ob wir bereits in einer Hash-URL sind
   */
  const isInHashMode = () => {
    return window.location.hash.length > 0;
  };

  /**
   * Universelle Navigation - verwendet Hash wenn nötig, sonst normales React Router
   */
  const universalNavigate = (path: string) => {
    if (isInHashMode() || !window.location.pathname.includes('/data')) {
      navigateWithHash(path);
    } else {
      navigate(path);
    }
  };

  return {
    navigateWithHash,
    universalNavigate,
    isInHashMode,
    navigate // Originale navigate-Funktion für Fallback
  };
}; 